import { ExportReportType } from '~/exportReport/exportReportType';
import { ExportReportPrintPageWrapperComponent } from '~/exportReport/printPage/exportReportPrintPageWrapper.component';
import type { ReportTemplate } from '~/exportReport/template/reportTemplate';
import { ExportReportTemplateRendererComponent } from '~/exportReport/templateRenderer/exportReportTemplateRenderer.component';
import { useExportReportData } from '~/exportReport/useExportReportData';
import { useExportReportParams } from '~/exportReport/useExportReportParams';
import { useLatLngSpreadsheetData } from '~/map/map/useSpreadsheetData.hook';
import type { ExportReportLocationParams } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.state';

type ExportReportPrintPageProps = Readonly<{
  params: ExportReportLocationParams;
  template: ReportTemplate;
}>;

export const ExportReportPrintPageLocationComponent = ({ template, params }: ExportReportPrintPageProps) => {
  const spreadsheetData = useLatLngSpreadsheetData();
  const rowData = spreadsheetData.getRow(params.data.markerId);
  const { tableColumns } = useExportReportParams();
  const { getDemographicData, getDemographicLabel } = useExportReportData({
    tableColumns,
    template,
  });

  if (!rowData || !template) {
    return null;
  }

  return (
    <ExportReportPrintPageWrapperComponent>
      <ExportReportTemplateRendererComponent
        template={template}
        summaryProps={{
          latLng: {
            lat: rowData.lat,
            lng: rowData.lng,
          },
          heading: params.data.summary.heading,
          semiHeading: params.data.summary.semiHeading,
          description: params.data.summary.description,
        }}
        mapProps={{
          type: ExportReportType.Location,
          center: rowData,
        }}
        tableColumns={tableColumns}
        getDemographicLabel={getDemographicLabel}
        getDemographicData={getDemographicData}
      />
    </ExportReportPrintPageWrapperComponent>
  );
};
